export const getTitleTypeFromSize = size => {
  switch (size) {
    case 'l':
      {
        return 'l';
      }
    case 's':
      {
        return 's';
      }
    default:
      {
        return 'm';
      }
  }
};